import { select } from "d3-selection"
import classNames from "classnames"
import { Component } from "react"
import PropTypes from "prop-types"
import { replace } from "lodash"

class Axis extends Component {
  static propTypes = {
    fn: PropTypes.func.isRequired,
    transform: PropTypes.string.isRequired,
    labelTransform: PropTypes.object,
    position: PropTypes.string,
    title: PropTypes.string,
    stroke: PropTypes.string,
  }

  draw = () => {
    const { ref, props: { fn } } = this

    select(ref)
      .call(fn)
  }

  componentDidUpdate() {
    this.draw()
  }

  setRef = node => {
    this.ref = node
    this.draw()
  }

  render() {
    const { transform, title, labelTransform, position, stroke } = this.props
    const className = classNames("axis", position)
    return <g ref={this.setRef} className={className} transform={transform}>
      <style type="text/css">
        {`.${replace(className, " ", ".")} .tick text{
          fill: ${stroke}
        }`}
        {position === "right" && `.${replace(className, " ", ".")} .tick line{
          stroke: ${stroke}
        }`}
      </style>
      {title && labelTransform
        && <g textAnchor="middle" transform={`translate(${labelTransform.x}, ${labelTransform.y})`}>
          <text
            fill={stroke}
            y={position === "right" ? -10 : 15}
            style={{
              transform: position === "right" ? "rotate(90deg)" : "rotate(-90deg)",
            }}
          >
            {title}
          </text>
        </g>}
    </g>
  }
}

Axis.defaultProps = {
  stroke: "black",
}

export default Axis
